/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AuditFilter, DownloadLogsParams, TableModel1AuditGet } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Audits<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Audit
   * @name GetAuditList
   * @summary Метод получения списка аудита
   * @request POST:/audits/list
   * @secure
   * @response `200` `TableModel1AuditGet` Список аудита
   */
  getAuditList = (data: AuditFilter, params: RequestParams = {}) =>
    this.request<TableModel1AuditGet, any>({
      path: `/audits/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Audit
   * @name DownloadLogs
   * @summary Экспорт логов
   * @request GET:/audits/DownloadLogs
   * @secure
   * @response `200` `File` Архив логов
   */
  downloadLogs = (query: DownloadLogsParams, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/audits/DownloadLogs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
